import axios from "axios";
import { toast } from "react-toastify";
import { OrganisationProductApi, ProductExploreApi } from ".";

export const fetchExploreProducts = (params) => {
  return axios
    .post(`${ProductExploreApi}`, params ?? {})
    .then((res) => {
      if (res?.data) {
        console.log("i-log> api response", res);
        return {
          products: res?.data?.product,
          total: res?.data?.total,
        };
      }
    })
    .catch(() => {});
};

export const createProduct = (params) => {
  return axios
    .post(OrganisationProductApi, params)
    .then((res) => {
      if (res?.data) {
        console.log("i-log> api response", res);
        return res?.data;
      }
    })
    .catch(() => {
      toast.error("Something went wrong while creating product");
    });
};

export const fetchOrganisationProducts = (params) => {
  return axios
    .get(OrganisationProductApi, params)
    .then((res) => {
      if (res?.data) {
        return res?.data;
      }
    })
    .catch(() => {
      toast.error("Something went wrong please try again later.");
    });
};
